export const HOTLINE = '028 7300 3588';
export const FINANCIAL_ACCOUNTING = '028 6679 7180';
